<script setup lang="ts">
import * as zagCheckbox from "@zag-js/checkbox";
import { normalizeProps, useMachine } from "@zag-js/vue";
import { computed, watch } from "vue";

const emit = defineEmits(["update"]);
interface Props {
	label: string;
	name?: string;
	value: boolean;
}

const props = defineProps<Props>();

const [state, send] = useMachine(
	zagCheckbox.machine({
		id: (Math.random() + 1).toString(36).substring(7),
		checked: props.value,
		onCheckedChange: ({ checked }) => emit("update", checked)
	})
);

const api = computed(() => zagCheckbox.connect(state.value, send, normalizeProps));

watch(
	() => props.value,
	() => api.value.setChecked(props.value)
);
</script>

<template>
	<label
		class="font-medium transition-colors text-base bg-white rounded inline-flex cursor-pointer h-9 items-center"
		:class="[api.isChecked ? 'border-black-light border-2 px-[15px]' : 'border-brown border border- px-[16px]']"
		v-bind="api.rootProps"
	>
		<span v-bind="api.labelProps">
			{{ label }}
		</span>
		<div v-bind="api.controlProps" />
		<input v-bind="api.hiddenInputProps" :name="name" />
	</label>
</template>
